import request from "./request";
import apis from "./apis";

const {
  classInfo,
  classSubjectInfo,
  updateClassSubject,
  classInfoByUserAccountId,
} = apis.section;

const section = {
  getClasses: (data: Object) => {
    return request.get(classInfo, data);
  },
  createClass: (data: Object) => {
    return request.post(classInfo, data);
  },
  updateClass: (data: Object) => {
    return request.put(classInfo, data);
  },
  deleteClass: (data: Object) => {
    return request.delete(classInfo, data);
  },
  getClassSubject: (data: Object) => {
    return request.get(classSubjectInfo, data);
  },
  updateClassSubject: (data: Object) => {
    return request.post(updateClassSubject, data);
  },
  getClassByUserAccountId: (data: Object) => {
    return request.get(classInfoByUserAccountId, data);
  },
};

export default section;